export default "__VITE_ASSET__QFY$7ILr__"